import _ from 'lodash'

export interface gamePlayConfig {
  [key: string]: {
    name: string
    name_en: string
    desc: string
    desc_en: string
    options?: string[]
    options_en?: string[]
    unit_en?: string
    unit?: string
    title?: string
    title_en?: string
  }
}

export enum i18nStoreType {
  customEvent = 'customEvent',
  tween = 'tween',
  drawLine = 'drawLine',
  gameConfigName = 'gameConfig:name',
  gameConfigDesc = 'gameConfig:desc',
  gameConfigOptions = 'gameConfig:options',
  gameConfigUnit = 'gameConfig:unit',
}

export interface i18nStoreItem {
  type: i18nStoreType
  id: string
  label: any
  labelEn: any
}

export function getEventAndTween(i18nStore: i18nStoreItem[]): i18nStoreItem[] {
  return i18nStore.filter((item) => {
    return (
      item.type === i18nStoreType.customEvent ||
      item.type === i18nStoreType.tween ||
      item.type === i18nStoreType.drawLine
    )
  })
}

// PT 中原有的 playConfig 需要转成 editorConfig i18nStore 的格式
export function gameConfigToi18nStore(
  gameConfig: gamePlayConfig,
  json_config: any,
): i18nStoreItem[] {
  const i18nStore: i18nStoreItem[] = []
  _.each(gameConfig, (value, key) => {
    if (typeof value.name_en !== 'undefined') {
      i18nStore.push({
        type: i18nStoreType.gameConfigName,
        id: key,
        label: value.title || value.name,
        labelEn: value.title_en || value.name_en,
      })
    }
    if (typeof value.desc_en !== 'undefined') {
      i18nStore.push({
        type: i18nStoreType.gameConfigDesc,
        id: key,
        label: value.desc,
        labelEn: value.desc_en,
      })
    }
    if (typeof value.options_en !== 'undefined') {
      const tkey = key.replace('[', '').replace(']', '')
      const gOptions = json_config?.gameConfig?.[tkey]?.options
      i18nStore.push({
        type: i18nStoreType.gameConfigOptions,
        id: key,
        label: JSON.stringify(value.options || gOptions || value.options_en), // options找不到就先去gameconfig里找，最后才读取options_en
        labelEn: JSON.stringify(value.options_en),
      })
    }
    if (typeof value.unit_en !== 'undefined') {
      i18nStore.push({
        type: i18nStoreType.gameConfigUnit,
        id: key,
        label: value.unit || value.unit_en,
        labelEn: value.unit_en,
      })
    }
  })
  return i18nStore
}

export function i18nStoreToGameConfig(
  i18nStoreItem: i18nStoreItem[],
): gamePlayConfig {
  const gameConfig: gamePlayConfig = {}
  _.each(i18nStoreItem, (value) => {
    if (typeof gameConfig[value.id] === 'undefined') {
      gameConfig[value.id] = {
        name: '',
        name_en: '',
        desc: '',
        desc_en: '',
      }
    }
    if (value.type === i18nStoreType.gameConfigName) {
      gameConfig[value.id]!.name = value.label
      gameConfig[value.id]!.name_en = value.labelEn
    }
    if (value.type === i18nStoreType.gameConfigDesc) {
      gameConfig[value.id]!.desc = value.label
      gameConfig[value.id]!.desc_en = value.labelEn
    }
    if (value.type === i18nStoreType.gameConfigOptions) {
      gameConfig[value.id]!.options = JSON.parse(value.label)
      gameConfig[value.id]!.options_en = JSON.parse(value.labelEn)
    }
    if (value.type === i18nStoreType.gameConfigUnit) {
      gameConfig[value.id]!.unit = value.label
      gameConfig[value.id]!.unit_en = value.labelEn
    }
  })
  return gameConfig
}
